type corpusData = {
	Name: string;
	UniqueWords: number;
	AverageUnique: number;
	TotalWords: number;
	AverageWords: number;
	ChapterSize: number[];
	// fileWords: { [name: string]: number };
};

const paulineData: corpusData[] =
[
	{
		"Name": "1 Corinthians",
		"UniqueWords": 2136,
		"AverageUnique": 133.5,
		"TotalWords": 6816,
		"AverageWords": 426,
		"ChapterSize": [
			500,
			287,
			340,
			345,
			221,
			334,
			688,
			226,
			449,
			 463,
			 529,
			 465,
			 197,
			 606,
			 843,
			 323
		]
	},
	{
		"Name": "2 Corinthians",
		"UniqueWords": 1526,
		"AverageUnique": 117.38,
		"TotalWords": 4476,
		"AverageWords": 344.3,
		"ChapterSize": [
			490,
			285,
			296,
			320,
			338,
			266,
			328,
			410,
			284,
			311,
			500,
			412,
			236
		]
	},
	{
		"Name": "Galatians",
		"UniqueWords": 920,
		"AverageUnique": 153.33,
		"TotalWords": 2228,
		"AverageWords": 371.33,
		"ChapterSize": [
			364,
			385,
			455,
			444,
			313,
			267
		]
	},
	{
		"Name": "Philippians",
		"UniqueWords": 713,
		"AverageUnique": 178.25,
		"TotalWords": 1628,
		"AverageWords": 407,
		"ChapterSize": [
			503,
			431,
			337,
			357
		]
	},
	{
		"Name": "Romans",
		"UniqueWords": 2146,
		"AverageUnique": 134.12,
		"TotalWords": 7057,
		"AverageWords": 441.06,
		"ChapterSize": [
			545,
			449,
			428,
			399,
			432,
			367,
			467,
			652,
			525,
			338,
			578,
			304,
			270,
			379,
			541,
			383
		]
	},
	{
		"Name": "1 Thessalonians",
		"UniqueWords": 589,
		"AverageUnique": 117.8,
		"TotalWords": 1476,
		"AverageWords": 295.2,
		"ChapterSize": [
			213,
			390,
			247,
			309,
			317
		]
	},
	{
		"Name": "Philemon",
		"UniqueWords": 204,
		"AverageUnique": 204,
		"TotalWords": 336,
		"AverageWords": 336,
		"ChapterSize": [336]
	}
];

export { type corpusData, paulineData }